<template>
    <el-row>
        <el-row>
            <el-dialog title="查看转换信息" :visible.sync="showDialog">
                <el-row>
                    <el-col :span="16" :offset="4">
                        <el-form label-width="100px">
                            <el-form-item label="实验名称：">
                                {{form.projectName}}
                            </el-form-item>
                            <el-form-item label="输入类型: ">
                                {{resForm.inputType}}
                            </el-form-item>
                            <el-form-item label="输入内容: ">
                                <a :href="form.inputContent" download>下载</a>
                            </el-form-item>
                            <el-form-item label="输出类型: ">
                                {{resForm.outputType}}
                            </el-form-item>
                            <el-form-item label="输出内容: ">
                                <a :href="resForm.outputContent" download>下载</a>
                            </el-form-item>
                        </el-form>
                    </el-col>
                </el-row>


            </el-dialog>
        </el-row>
        <el-row v-loading="onLoading">
            <el-form :model="form" label-width="100px" class="demo-form-inline">
                <el-row>
                    <h3>实验名称：</h3>
                </el-row>
                <el-form-item>
                    <el-row>
                        <el-col :span="6">
                            <el-input v-model="form.projectName"></el-input>
                        </el-col>
                    </el-row>

                </el-form-item>


                <el-row>
                    <h3>进行转换: </h3>
                </el-row>
                <el-row>
                    <el-col :span="6" :offset="2">
                        <el-row class="box-shadow" style="min-height: 350px">
                            <h5 style="margin-left: 10px">请选择输入内容：</h5>
                            <el-form-item >
                                <el-select v-model="form.inputType" @change="inputTypeChange">
                                    <el-option v-for="item in typeOptions" :key="item.value" :label="item.label"
                                               :value="item.value"></el-option>
                                </el-select>
                                <el-row style="margin-top: 10px">
                                    <el-upload class="upload-demo"
                                               v-if="uploadShow"
                                               action=""
                                               :limit="1"
                                               :file-list="form.targetFileList"
                                               list-type="picture"
                                               :http-request="httpUpload" :on-change="onUploadChange">
                                        <el-button type="primary">upload</el-button>

                                    </el-upload>
                                    <el-input v-model="form.inputContent" v-if="inputShow" placeholder="请输入Smiles结构式"></el-input>
                                </el-row>

                            </el-form-item>
                        </el-row>


                    </el-col>
                    <el-col :span="4">
                        <el-row style="margin-top: 20px;text-align: center">
                            <i class="el-icon-d-arrow-right"></i>
                        </el-row>
                        <el-row style="margin-top: 20px;text-align: center">
                            <el-button icon="el-icon-plus" circle @click="addNewType"></el-button>
                        </el-row>

                    </el-col>
                    <el-col :span="8" class="box-shadow" style="height: 350px">
                        <el-row>
                            <h5 style="margin-left: 10px">请选择输出内容: </h5>
                        </el-row>
                        <el-row v-for="(item, index) in form.outputItems" :key="item.index" style="margin-top: 10px">
                            <el-select v-model="item.outputType" style="margin-left: 20px">
                                <el-option v-for="(item, index) in outPutTypeOptions" :key="item.value"
                                           :label="item.label" :value="item.value"></el-option>
                            </el-select>
                            <el-button type="primary" style="margin-left: 20px" @click="convert(index)">转换</el-button>
                            <el-button type="primary" @click="showRes(index)">查看</el-button>
                        </el-row>

                    </el-col>
                </el-row>

            </el-form>
        </el-row>

    </el-row>
</template>

<script>
    export default {
        name: "Convertor",
        data() {
            return {
                showDialog: false,
                typeSelect: '',
                typeOptions: [
                    {
                        value: '0',
                        label: 'png'
                    },
                    {
                        value: '1',
                        label: 'SMILE'
                    },
                    {
                        value: '2',
                        label: 'MOL'
                    },

                    {
                        value: '3',
                        label: 'SDF',
                    },
                    {
                        value: '4',
                        label: 'SMILE STRING'
                    }
                ],
                outPutTypeOptions: [
                    {
                        value: '0',
                        label: 'SDF'
                    },
                    {
                        value: '1',
                        label: 'MOL'
                    },
                    {
                        value: '2',
                        label: 'CANONICAL_SMILE'
                    },
                ],
                form: {
                    projectName: '',
                    inputType: '',
                    inputContent: '',
                    targetFileList: [],
                    outputItems: [{
                        outputType: '',
                        outputValue: ''
                    }]
                },
                //接收其他组件传递的化合物信息
                infoForm: {
                    SampleInfo: {
                        TargetPng: '',
                        TargetSmiles: '',
                        TargetMolfile: '',
                        TargetSDF:''
                    }
                },
                resForm: {
                    inputType: '',
                    inputContent: '',
                    outputType: '',
                    outputContent: ''
                },
                onLoading: false,
                uploadShow: false,
                inputShow: false
            }
        },
        methods: {
            httpUpload: function (param) {
                let formData = new FormData();
                formData.append('files', param.file);
                formData.set('username', this.$store.state.userId);
                formData.set('compoundsId', '');
                if (this.infoForm.id != undefined) {
                    formData.set('compoundsId', this.infoForm.id)
                }
                let _this = this;
                this.onLoading = true;

                this.$api.filePost('/datacenter/saveCompoundsFiles', formData, (res) => {
                    this.onLoading = false;
                    if (res.data.code == 200) {
                        let fileVo = res.data.data[0];
                        _this.form.inputContent = fileVo.path;
                    } else {
                        this.$message({
                            type: 'warning',
                            message: `${res.data}`
                        })
                    }
                })
            },
            onUploadChange: function (file, fileList) {
                console.log('files monitor');
                this.form.targetFileList = fileList;
            },
            addNewType: function () {
                if (this.form.outputItems.length < this.typeOptions.length) {
                    this.form.outputItems.push({
                        outputType: '',
                        outputValue: ''
                    })
                }

            },
            convert: function (index) {
                let _this = this;
                this.onLoading = true;
                this.$api.post('/datacenter/convertor', {
                    inputType: this.form.inputType,
                    inputContent: this.form.inputContent,
                    outputType: this.outPutTypeOptions[Number(this.form.outputItems[index].outputType)].value,
                    compoundId: this.infoForm.id
                }, (res) => {
                    _this.onLoading = false;
                    if (res.data.code == 200) {
                        console.log('Convert success!');
                        console.log(res.data);
                        _this.form.outputItems[index].outputValue = res.data.data;
                        if (res.data.data == '') {
                            this.$message({
                                type: 'warning',
                                message: '转换失败请输入正确的格式'
                            })
                        }

                    }
                })
            },
            showRes: function (index) {
                if (this.form.outputItems[index].outputValue == undefined || this.form.outputItems[index].outputValue == '') {
                    this.$message({
                        type: 'warning',
                        message: '请先执行转换操作'
                    })
                } else {
                    this.resForm = {
                        inputType: this.typeOptions[this.form.inputType].label,
                        inputContent: this.form.inputContent,
                        outputType: this.outPutTypeOptions[Number(this.form.outputItems[index].outputType)].label,
                        outputContent: this.form.outputItems[index].outputValue
                    }
                    this.showDialog = true;
                }

            },
            updateFormTargetFileList: function (path) {
                this.uploadShow = true;
                this.inputShow = false;
                if (path.length > 0) {
                    this.form.targetFileList = [{name: path, url: path}]
                    this.form.inputContent = path
                } else {
                    this.form.targetFileList = []
                }
            },
            inputTypeChange: function (index) {
                console.log(`<< inputTypeChange >> ${index}`);
                /**
                 * 0:
                 * */
                switch (index + '') {
                    case '0':
                        if (this.infoForm.SampleInfo.TargetPic == undefined) {
                            this.infoForm.SampleInfo.TargetPic = ''
                        }
                        this.updateFormTargetFileList(this.infoForm.SampleInfo.TargetPic);
                        break;
                    //Smiles
                    case '1':
                        if (this.infoForm.SampleInfo.TargetSmiles == undefined) {
                            this.infoForm.SampleInfo.TargetSmiles = ''
                        }
                        this.updateFormTargetFileList(this.infoForm.SampleInfo.TargetSmiles);
                        break;

                    //Molfiles
                    case '2':
                        if (this.infoForm.SampleInfo.TargetMolfile == undefined) {
                            this.infoForm.SampleInfo.TargetMolfile = ''
                        }
                        this.updateFormTargetFileList(this.infoForm.SampleInfo.TargetMolfile);
                        break;
                    //SDF
                    case '3':
                        this.updateFormTargetFileList('');
                        break;
                    //Smile string
                    case '4':
                        this.inputShow = true;
                        this.uploadShow = false;
                        break;
                    default:
                        break;

                }
                console.log(this.form.targetFileList);
            }

        },
        mounted() {
            if (this.$store.state.infoForm.MethodInfo != undefined) {
                this.infoForm = this.$store.state.infoForm;
                this.form.projectName = this.infoForm.SampleInfo.Project;
                this.$store.commit('updateInfoForm', {});
            }

        }
    }
</script>

<style scoped>
    .box-shadow {
        box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04)
    }

</style>